<div class='header-line' fxLayout fxLayoutAlign='space-between center'>
  <div fxLayout fxLayoutAlign='start center' fxLayoutGap='48px'>
    <ng-template #descriptionTemplate>
      <div class="description-template" [innerHTML]="formatInnerText(cardDescription | linkify)"></div>
    </ng-template>

    <div class='table-title'>{{ dashboardTitle }}</div>

    <mat-icon
      class="info-icon"
      [matTooltip]="'OPEN_DESCRIPTION' | translate"
      [matTooltipPosition]="'above'"
      (click)='openDescription(descriptionTemplate)'
    >info</mat-icon>

<!--    <app-filter-bar-->
<!--      *ngIf="initDates"-->
<!--      [filters]="['dateRange']"-->
<!--      [initialValue]="initDates"-->
<!--      [smallNewDateRange]="true"-->
<!--      [preventFiltersStore]="true"-->
<!--      (filterChanges)="onFilterChanges($event)"-->
<!--    ></app-filter-bar>-->

    <mat-form-field>
      <input matInput [matDatepicker]="picker" [formControl]="dateFilter" (click)="picker.open()">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </div>
</div>

<div class="progress-bar-wrapper" style="margin-top: 16px">
  <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
</div>

<ng-container *ngIf="
                !isLoading &&
                (regionDataSource.length || orderDataSource.length) &&
                (orderDisplayedColumns.length || regionDisplayedColumns.length)
">
  <h3 class="table-title" style="margin-top: 24px">{{'CONVERSIONS.REGION' | translate}}</h3>

  <div class="container">
    <mat-table [dataSource]="regionDataSource" class="mat-elevation-z1">
      <ng-container *ngFor="let col of regionDisplayedColumns" [matColumnDef]="col">
        <mat-header-cell *matHeaderCellDef>

          <ng-container *ngIf="col === 'region'">
            {{ 'CRITICAL_ORDERS.REGION' | translate }}
          </ng-container>

          <ng-container *ngIf="col !== 'region'">
            {{ CONVERSION_KEY_MAP[col] | translate }}
          </ng-container>

        </mat-header-cell>

        <mat-cell *matCellDef="let element">
          {{ toPercent(element[col]) }}
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="regionDisplayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: regionDisplayedColumns"></mat-row>
    </mat-table>
  </div>

  <h3 class="table-title" style="margin-top: 32px">{{'CONVERSIONS.ORDERS' | translate}}</h3>

  <div class="container">
    <mat-table [dataSource]="orderDataSource" class="mat-elevation-z1">
      <ng-container *ngFor="let col of orderDisplayedColumns" [matColumnDef]="col">

        <mat-header-cell *matHeaderCellDef>
          {{ CONVERSION_KEY_MAP[col] | translate }}
        </mat-header-cell>

        <mat-cell *matCellDef="let row">
          <span [ngClass]="{ 'red-cell': row[col]?.isLower }">
            {{ row[col]?.value !== undefined ? toPercent(row[col].value) : toPercent(row[col]) }}
          </span>
        </mat-cell>

      </ng-container>

      <mat-header-row *matHeaderRowDef="orderDisplayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: orderDisplayedColumns"></mat-row>
    </mat-table>
  </div>
</ng-container>
